var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"resourceTile cs-orange-learn",attrs:{"to":_vm.moduleLink}},[_c('div',{staticClass:"resourceTileInner"},[_c('img',{attrs:{"src":_vm.thumbnail}}),_c('div',{staticClass:"resourceText"},[_c('h2',[_vm._v(_vm._s(_vm.module.title))]),_c('h3')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }